var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "preview"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "logoBox"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "placement": "bottom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', [_vm._v("Partyline(ENV: " + _vm._s(_vm.applicationName) + "):"), _c('br'), _vm._v("Frontend: " + _vm._s(_vm.fontVersion)), _c('br'), _vm._v("Backend: " + _vm._s(_vm.backendVersion))])]), _c('div', {
    staticClass: "logoContent"
  }, [_c('svg', {
    staticClass: "logoSvg",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.logoSvg
    }
  })])])]), _c('span', {
    staticClass: "logoText"
  }, [_vm._v(_vm._s(_vm.State.logoTitle))])], 1), _c('div', {
    staticClass: "noLoginLang"
  }, [_c('div', {
    staticClass: "pointer common",
    on: {
      "click": function ($event) {
        return _vm.setTheme(!_vm.isDark ? 'dark' : 'light');
      }
    }
  }, [_c('span', {
    staticClass: "theme"
  }, [!_vm.isDark ? _c('i', {
    staticClass: "iconfont icon-Frame2"
  }) : _c('i', {
    staticClass: "iconfont icon-a-Frame11"
  })]), _c('span', {
    staticClass: "fontTheme"
  }, [!_vm.isDark ? _c('span', [_vm._v(_vm._s(_vm.$t('common.light')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('common.dark')))])])]), _c('div', {
    staticClass: "common",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.changeParticipantLanguage
    }
  }, [_c('span', {
    staticClass: "iconLang"
  }, [_vm.$i18n.locale === 'zh' ? _c('i', {
    staticClass: "iconfont icon-a-V2chinese"
  }) : _c('i', {
    staticClass: "iconfont icon-a-V2English"
  })]), _c('span', {
    staticClass: "fontLang"
  }, [_vm.$i18n.locale === 'zh' ? _c('p', [_vm._v("中文")]) : _c('p', [_vm._v("English")])])])])]), _c('div', {
    staticClass: "contentBox"
  }, [_c('div', {
    staticClass: "contentLeft"
  }, [_c('div', {
    staticClass: "videoBox"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    attrs: {
      "id": "local_stream"
    }
  }), _vm.showNotNeedVideoBox ? _c('div', {
    staticClass: "notNeedVideo"
  }, [_vm._v(_vm._s(_vm.showNotNeedVideoText))]) : _vm._e()]), _c('div', {
    staticClass: "mediaControl"
  }, [_c('div', {
    staticClass: "deviceIconBox m_r_70"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.showDeviceTips('camera', _vm.camera, _vm.devicesInfo),
      "placement": "top"
    }
  }, [_vm.cameraOn ? _c('i', {
    staticClass: "iconfont icon-a-V2cameraon",
    on: {
      "click": function ($event) {
        return _vm.setCameraOrMic('muteVideo');
      }
    }
  }) : _vm._e(), _vm.cameraOff ? _c('i', {
    staticClass: "iconfont icon-a-V2cameraoff",
    class: _vm.cameraOffClass,
    on: {
      "click": function ($event) {
        return _vm.setCameraOrMic('muteVideo');
      }
    }
  }) : _vm._e()]), _vm.devicesInfo.cameraList && _vm.devicesInfo.cameraList.length ? _c('device-select', {
    ref: "cameraDevice",
    attrs: {
      "title": _vm.$t('operationBtn.selectCamera'),
      "type": "video",
      "deviceSelectId": _vm.devicesInfo.cameraId,
      "data": _vm.devicesInfo.cameraList
    },
    on: {
      "changeDevice": _vm.changeDevice
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "deviceIconBox m_r_70"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.showDeviceTips('microphone', _vm.mic, _vm.devicesInfo),
      "placement": "top"
    }
  }, [_vm.mic && _vm.devicesInfo.microphoneList && _vm.devicesInfo.microphoneList.length ? _c('i', {
    staticClass: "iconfont icon-a-V2micon",
    on: {
      "click": function ($event) {
        return _vm.setCameraOrMic('muteAudio');
      }
    }
  }) : _c('i', {
    staticClass: "iconfont icon-a-V2micoff",
    on: {
      "click": function ($event) {
        return _vm.setCameraOrMic('muteAudio');
      }
    }
  })]), _vm.devicesInfo.microphoneList && _vm.devicesInfo.microphoneList.length ? _c('device-select', {
    attrs: {
      "title": _vm.$t('operationBtn.selectMicrophone'),
      "type": "audio",
      "deviceSelectId": _vm.devicesInfo.microphoneId,
      "data": _vm.devicesInfo.microphoneList
    },
    on: {
      "changeDevice": _vm.changeDevice
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "deviceIconBox"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.showDeviceTips('speaker', _vm.speaker, _vm.devicesInfo),
      "placement": "top"
    }
  }, [_vm.speaker ? _c('i', {
    staticClass: "iconfont icon-a-V2speakeron",
    on: {
      "click": function ($event) {
        return _vm.changeMute(true);
      }
    }
  }) : _c('i', {
    staticClass: "iconfont icon-a-V2speakeroff",
    on: {
      "click": function ($event) {
        return _vm.changeMute(false);
      }
    }
  })]), _vm.devicesInfo.speakerList && _vm.devicesInfo.speakerList.length ? _c('device-select', {
    attrs: {
      "title": _vm.$t('operationBtn.selectSpeaker'),
      "type": "speaker",
      "deviceSelectId": _vm.devicesInfo.speakerId,
      "data": _vm.devicesInfo.speakerList
    },
    on: {
      "changeDevice": _vm.changeDevice
    }
  }) : _vm._e()], 1)]), _vm._m(0), (!_vm.localVideoTrack && !_vm.State.showInitCameraTips || _vm.showInitMessage) && _vm.checkInfo.channelModel != 1 && _vm.checkInfo.channelModel != 13 && _vm.checkInfo.channelModel != 18 ? _c('p', {
    staticClass: "initCameraTips"
  }, [_vm._v(_vm._s(_vm.$t('common.initVideoTrack')))]) : _vm._e(), _vm.State.showInitCameraTips ? _c('p', {
    staticClass: "initCameraTips"
  }, [_vm._v(_vm._s(_vm.$t('common.initCameraTips', {
    name: _vm.cameraName
  })))]) : _vm._e()]), _c('div', {
    staticClass: "testMic"
  }, [_c('span', {
    on: {
      "click": _vm.openTestMic
    }
  }, [_vm._v(_vm._s(_vm.$t('partyInfo.testMic')))])])]), _c('div', {
    staticClass: "contentRight"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('common.participateSetting')))]), _vm.checkInfo.owner ? _c('div', {
    staticClass: "partyName"
  }, [_c('i', {
    staticClass: "iconfont icon-required redColor"
  }), _c('span', {
    staticClass: "commonSpan"
  }, [_vm._v(_vm._s(_vm.$t('common.title')))]), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.returnPartyID,
      "placement": "top"
    }
  }, [_c('el-input', {
    staticClass: "commonInput",
    model: {
      value: _vm.partyName,
      callback: function ($$v) {
        _vm.partyName = $$v;
      },
      expression: "partyName"
    }
  })], 1)], 1) : _vm._e(), _vm.checkInfo.inviteMode == 3 && !_vm.checkInfo.owner ? _c('div', {
    staticClass: "passCode"
  }, [_c('i', {
    staticClass: "iconfont icon-required redColor"
  }), _c('span', {
    staticClass: "commonSpan"
  }, [_vm._v(_vm._s(_vm.$t('invite.passCode')))]), _c('el-input', {
    staticClass: "commonInput",
    model: {
      value: _vm.passCode,
      callback: function ($$v) {
        _vm.passCode = $$v;
      },
      expression: "passCode"
    }
  })], 1) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showNickNameInput,
      expression: "showNickNameInput"
    }],
    staticClass: "nickName"
  }, [_c('i', {
    staticClass: "iconfont icon-required redColor"
  }), _c('span', {
    staticClass: "commonSpan"
  }, [_vm._v(_vm._s(_vm.$t('common.nickName')))]), _c('el-input', {
    staticClass: "commonInput",
    model: {
      value: _vm.splitEmail,
      callback: function ($$v) {
        _vm.splitEmail = $$v;
      },
      expression: "splitEmail"
    }
  })], 1), _vm.State.channelModeByRouteName[_vm.checkInfo.channelModel] === 'coordinator' ? _c('div', {
    staticClass: "nickName"
  }, [_c('span', {
    staticClass: "commonSpan"
  }, [_vm._v(_vm._s(_vm.$t('startNewParty.corporation')))]), _c('el-input', {
    staticClass: "commonInput",
    attrs: {
      "maxlength": 256
    },
    model: {
      value: _vm.organization,
      callback: function ($$v) {
        _vm.organization = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "organization"
    }
  })], 1) : _vm._e(), _c('el-divider', {
    staticClass: "settingDivider"
  }), _c('div', {
    staticClass: "foot"
  }, [!_vm.checkInfo.owner ? _c('div', {
    staticClass: "nameBox"
  }, [_c('span', {
    staticClass: "nameCommonSpan"
  }, [_vm._v(_vm._s(_vm.$t('common.title')))]), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.returnPartyID,
      "placement": "top"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.showPartyName))])])], 1) : _vm._e(), _c('div', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "leftMode"
  }, [_vm._v(_vm._s(_vm.$t('common.partyMode')))]), _c('span', [_vm._v(_vm._s(_vm.State.channelModeByRouteName[_vm.checkInfo.channelModel] ? _vm.$t(`commonPartyHost.leftPane.title.${_vm.State.channelModeByRouteName[_vm.checkInfo.channelModel]}`) : ''))])]), _vm.partyCode.length !== 16 && !_vm.modelType ? _c('div', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "grayColor"
  }, [_vm._v(_vm._s(_vm.$t('partyInfo.maxLimit')) + ":")]), _c('span', [_vm._v("50")])]) : _vm._e()]), _c('el-button', {
    staticClass: "join",
    on: {
      "click": _vm.jumpPage
    }
  }, [_vm._v(_vm._s(_vm.checkInfo.owner ? _vm.$t('common.startNow') : _vm.$t('start.join')))]), !_vm.checkInfo.owner ? _c('div', {
    staticClass: "pointer anywhereBtn",
    on: {
      "click": _vm.dealAnywhereInstall
    }
  }, [_vm._v(_vm._s(_vm.$t('common.installAnyWhereText')))]) : _vm._e()], 1)]), _c('guide-page', {
    attrs: {
      "dialogVisible": _vm.State.guideObjShow
    }
  }), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('partyInfo.MicTest'),
      "visible": _vm.testMicVisible,
      "width": "484px",
      "close-on-click-modal": false,
      "append-to-body": "",
      "custom-class": "MicTest"
    },
    on: {
      "update:visible": function ($event) {
        _vm.testMicVisible = $event;
      },
      "close": _vm.closeMic,
      "closed": _vm.closedMic
    }
  }, [_c('div', {
    staticClass: "MicContent"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('partyInfo.MicrophoneSelection')))]), _c('div', {
    staticClass: "micSelect"
  }, [_c('el-select', {
    attrs: {
      "popper-append-to-body": false
    },
    on: {
      "change": _vm.handleAudio
    },
    model: {
      value: _vm.deviceId,
      callback: function ($$v) {
        _vm.deviceId = $$v;
      },
      expression: "deviceId"
    }
  }, _vm._l(_vm.devicesInfo.microphoneList, function (item) {
    return _c('el-option', {
      key: item.deviceId,
      attrs: {
        "label": item.label,
        "value": item.deviceId,
        "popper-append-to-body": true
      }
    });
  }), 1), _c('button', {
    staticClass: "micButton",
    class: {
      start: !_vm.startOrStop,
      stop: _vm.startOrStop
    },
    on: {
      "click": _vm.startTesting
    }
  }, [_vm._v(_vm._s(_vm.startOrStop ? _vm.$t('partyInfo.stopTesting') : _vm.$t('partyInfo.startTesting')))])], 1), _c('div', {
    staticClass: "volumeContent"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('partyInfo.inputLevel')))]), _c('i', {
    staticClass: "iconfont icon-universal_micon"
  }), _c('div', {
    staticClass: "volume"
  }, [_c('canvas', {
    staticClass: "volumeLeft"
  })])]), _c('p', {
    staticClass: "note"
  }, [_vm._v(_vm._s(_vm.$t('partyInfo.note')))])])])], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "volume"
  }, [_c('canvas', {
    staticClass: "volumeLeft"
  }), _c('canvas', {
    staticClass: "volumeRight"
  })]);
}];
export { render, staticRenderFns };